import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/analytics";
import "firebase/functions";

const config = {
  apiKey: "AIzaSyCZdXgcDnQXJyx7JAqxaUE9mqTWvZJFZug",
  authDomain: "astute-nuance-275600.firebaseapp.com",
  databaseURL: "https://astute-nuance-275600.firebaseio.com",
  projectId: "astute-nuance-275600",
  storageBucket: "astute-nuance-275600.appspot.com",
  messagingSenderId: "767270070760",
  appId: "1:767270070760:web:01342f1b367bbe77121c5d",
  measurementId: "G-Y49W4GZGD7",
};

firebase.initializeApp(config);

const db = firebase.firestore();
const firestore = firebase.firestore;
const auth = firebase.auth();
const currentUser = auth.currentUser;
// Initialize Cloud Functions through Firebase
const functions = firebase.functions();
const analytics = firebase.analytics();

if (window.location.hostname === "localhost") {
  firebase.functions().useFunctionsEmulator("http://localhost:5001");
}

auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

const usersCollection = db.collection("users");

export {
  auth,
  currentUser,
  usersCollection,
  db,
  firestore,
  functions,
  analytics,
};
